import { getEspot } from '@utils/services';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

interface Props {
    setQuantity: (boxes: number) => void;
    quantityS?: string;
    quantityB: any;
}

const noDiscount = {
    annualSupplyBoxes: 0,
    sixMonthsSupplyBoxes: 0,
    annualSupplySavings: 0,
    sixMonthsSupplySavings: 0,
};

const CLDiscounts = ({ setQuantity, quantityS, quantityB }: Props) => {
    const config = useSelector((state: RootState) => state.common.config);

    const discountData = config?.discountData || noDiscount;

    const { annualSupplyBoxes, sixMonthsSupplyBoxes, annualSupplySavings, sixMonthsSupplySavings } =
        discountData;

    const showAnnualSupply = annualSupplyBoxes > 0;
    const showSixMonthsSupply = sixMonthsSupplyBoxes > 0;

    // only show this section if there are discounts available
    const showDiscountSection = showAnnualSupply || showSixMonthsSupply;

    const annualBoxesPerEye = annualSupplyBoxes / 2;
    const sixMonthsBoxesPerEye = sixMonthsSupplyBoxes / 2;

    const [selectedOption, setSelectedOption] = useState(null);

    const [formattedEspotContent, setFormattedEspotContent] = useState(null);

    useEffect(() => {
        var totBoxes = parseInt(quantityB.leftQuantity) + parseInt(quantityB.rightQuantity);
        if (!!totBoxes && totBoxes.toString() === annualSupplyBoxes.toString()) {
            setSelectedOption('annual');
        } else if (!!totBoxes && totBoxes.toString() === sixMonthsSupplyBoxes.toString()) {
            setSelectedOption('sixMonths');
        } else {
            setSelectedOption('');
        }
    }, [quantityS, quantityB]);

    const handleClick = (quantity: number, option: string) => {
        setQuantity(quantity);
        setSelectedOption(option);
    };

    useEffect(() => {
        getEspot(
            'https://' + window.location.hostname,
            config.storeId.toString(),
            'X_PDP_CL_Supply_Section'
        )
            .then(res => {
                if (res) {
                    var result = JSON.parse(res.toString());
                    var copyAnnualSupply = { boldText: null, normalText: null };
                    var copySixMonthsSupply = { boldText: null, normalText: null };
                    if (!!result['annual-supply'] && result['annual-supply'].includes('<b>')) {
                        copyAnnualSupply.boldText =
                            result['annual-supply'].match(/<b>(.*?)<\/b>/)[1];
                        copyAnnualSupply.normalText = result['annual-supply']
                            .replace(/<b>.*?<\/b>/, '')
                            .trim();
                    } else if (!!result['annual-supply']) {
                        copyAnnualSupply.normalText = result['annual-supply'];
                    }
                    if (
                        !!result['six-months-supply'] &&
                        result['six-months-supply'].includes('<b>')
                    ) {
                        copySixMonthsSupply.boldText =
                            result['six-months-supply'].match(/<b>(.*?)<\/b>/)[1];
                        copySixMonthsSupply.normalText = result['six-months-supply']
                            .replace(/<b>.*?<\/b>/, '')
                            .trim();
                    } else if (!!result['six-months-supply']) {
                        copySixMonthsSupply.normalText = result['annual-supply'];
                    }
                    result['annual-supply-copy'] = copyAnnualSupply;
                    result['six-months-supply-copy'] = copySixMonthsSupply;
                    setFormattedEspotContent(result);
                }
            })
            .catch(err => {
                console.error(
                    '>>> Get empty cart espot => error status:',
                    err.status,
                    ', error: ',
                    err
                );
            });
    }, []);

    return (
        <>
            {showDiscountSection && (
                <div className="contact-lens-discount-container">
                    {showAnnualSupply && formattedEspotContent && (
                        <div
                            className="annual-supply-discount"
                            onClick={() => handleClick(annualBoxesPerEye, 'annual')}
                        >
                            <span className="one_year_boxes d-none">{annualSupplyBoxes}</span>
                            <span className="supply-tooltip">
                                {formattedEspotContent['supply-tooltip'] &&
                                    formattedEspotContent['supply-tooltip'].replace(
                                        '##numBoxes##',
                                        annualSupplyBoxes
                                    )}
                            </span>
                            <input
                                type="radio"
                                id="annual-supply"
                                name="supply-option"
                                checked={selectedOption === 'annual'}
                                readOnly
                            />
                            <label
                                htmlFor="annual-supply"
                                style={{ color: formattedEspotContent['annual-supply-color'] }}
                            >
                                {formattedEspotContent['annual-supply-copy'] &&
                                    formattedEspotContent['annual-supply-copy'].boldText && (
                                        <b>
                                            {formattedEspotContent[
                                                'annual-supply-copy'
                                            ].boldText.replace('##supply##', annualSupplySavings)}
                                        </b>
                                    )}{' '}
                                {formattedEspotContent['annual-supply-copy'] &&
                                    formattedEspotContent['annual-supply-copy'].normalText &&
                                    formattedEspotContent['annual-supply-copy'].normalText
                                        .replace('##numBoxes##', annualSupplyBoxes)
                                        .replace('##supply##', annualSupplySavings)}
                            </label>
                        </div>
                    )}

                    {showSixMonthsSupply && formattedEspotContent && (
                        <div
                            className="annual-supply-discount"
                            onClick={() => handleClick(sixMonthsBoxesPerEye, 'sixMonths')}
                        >
                            <span className="six_months_boxes d-none">{sixMonthsSupplyBoxes}</span>
                            <span className="supply-tooltip">
                                {formattedEspotContent['supply-tooltip'] &&
                                    formattedEspotContent['supply-tooltip'].replace(
                                        '##numBoxes##',
                                        sixMonthsSupplyBoxes
                                    )}
                            </span>
                            <input
                                type="radio"
                                id="six-months-supply"
                                name="supply-option"
                                checked={selectedOption === 'sixMonths'}
                                readOnly
                            />
                            <label
                                htmlFor="six-months-supply"
                                style={{
                                    color: formattedEspotContent['six-months-supply-color'],
                                }}
                            >
                                {formattedEspotContent['six-months-supply-copy'] &&
                                    formattedEspotContent['six-months-supply-copy'].boldText && (
                                        <b>
                                            {formattedEspotContent[
                                                'six-months-supply-copy'
                                            ].boldText.replace(
                                                '##supply##',
                                                sixMonthsSupplySavings
                                            )}
                                        </b>
                                    )}{' '}
                                {formattedEspotContent['six-months-supply-copy'] &&
                                    formattedEspotContent['six-months-supply-copy'].normalText &&
                                    formattedEspotContent['six-months-supply-copy'].normalText
                                        .replace('##numBoxes##', sixMonthsSupplyBoxes)
                                        .replace('##supply##', sixMonthsSupplySavings)}
                            </label>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default CLDiscounts;
